import styles from "./styles.module.scss";
import { PaginationProps } from "./types";

export default function Pagination({
	currentPage,
	totalPages,
	onPageChange
}: PaginationProps) {
	const getPages = () => {
		const pages: (number | string)[] = [];

		if (totalPages <= 6) {
			for (let i = 1; i <= totalPages; i += 1) {
				pages.push(i);
			}
		} else {
			pages.push(1);

			const start = Math.max(2, currentPage - 1);
			const end = Math.min(totalPages - 1, currentPage + 1);

			if (currentPage <= 2) {
				for (let i = 2; i <= 3; i += 1) {
					pages.push(i);
				}
				pages.push("...");
			} else {
				if (start > 2) pages.push("...");
				for (let i = start; i <= end; i += 1) {
					pages.push(i);
				}
				if (currentPage < totalPages - 2) pages.push("...");
			}

			pages.push(totalPages);
		}

		return pages;
	};

	return (
		<div className={styles.pagination}>
			{getPages().map((page, index) =>
				page === "..." ? (
					<span key={index} className={styles.ellipsis}>
						...
					</span>
				) : (
					<button
						key={index}
						className={`${styles.page} ${
							currentPage === page ? styles.active : ""
						}`}
						onClick={() => onPageChange(page as number)}
					>
						{page}
					</button>
				)
			)}
		</div>
	);
}
